<template>
  <div class="page">
    <div class="score-block" v-if="showAnswer">
        您本次模拟考试得分为：<span>{{myScore}}分</span>
        <p>以下是您的错题及答案：</p>
    </div>
    <!-- 选择题 -->
	<div class="choose-q-block" v-for="(item, index) in examList" :key="index" :id="'elem'+index">
		<div class="choice-q-title">{{item.pTitle}}
            <span v-if="item.questionType === 1">单选</span>
            <span v-if="item.questionType === 2" class="dx">多选</span>
            <span v-if="item.questionType === 3" class="pd">判断</span>
        </div>
		<p class="abcd abcd-a" :class="item.myAnswer.includes('A') ? 'active': ''" @click="onTrueAnswer(index,'A')"><span>{{item.optionA}}</span></p>
		<p class="abcd abcd-b" :class="item.myAnswer.includes('B') ? 'active': ''" @click="onTrueAnswer(index,'B')"><span>{{item.optionB}}</span></p>
		<p class="abcd abcd-c" v-if="item.optionC" :class="item.myAnswer.includes('C')? 'active': ''" @click="onTrueAnswer(index,'C')"><span>{{item.optionC}}</span></p>
		<p class="abcd abcd-d" v-if="item.optionD" :class="item.myAnswer.includes('D')? 'active': ''" @click="onTrueAnswer(index,'D')"><span>{{item.optionD}}</span></p>
        <p class="answer" v-if="showAnswer && !item.trueOrFalse">正确答案：{{ item.rightAnswer }}</p>
	</div>
    <div class="confirm-btn" v-if="!showAnswer" @click="submit">回答完成，提交</div>
    <div class="confirm-btn" v-else @click="reloadNewExam">再来一次</div>
  </div>
</template>

<script>
import {getExamQuestion, finishExam} from '@/common/api.js'

export default {
    data() {
        return {
            examList: [],
            showAnswer: false,
            reqQuery: {
                nuserId: Number(this.$getStorage('engineerRExamUserId')),
            },
            myScore: 0
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init() {
            this.fetchExamList();
        },
        fetchExamList () {
            getExamQuestion(this.reqQuery).then(r=>{
                if (r.Result == 1 && r.Data) {
                    let examList = r.Data.examQuestionsVOList || [];
                    examList.map((item,index)=> {
                        item.pTitle = `题目${index +1}、${item.questions}`;
                        item.myAnswer = ''; // 我的答案
                        console.log("index", item.pTitle);
                        return item;
                    })
                    console.log("index --- ",examList);
                    this.examList = examList;
                }else {
                    this.$toast(r.Message);
                }
            });
        },
        onTrueAnswer(index,chooseAnswer) {
            if(this.showAnswer) return;
            let item = this.examList[index];
            // 单选 判断
            if(item.questionType == 1 || item.questionType == 3) {
                item.myAnswer = chooseAnswer
            }
            // 多选
            if(item.questionType == 2) {
                if(item.myAnswer.includes(chooseAnswer)){
                    item.myAnswer = item.myAnswer.split('').filter(item => item !== chooseAnswer).join('');
                }else {
                    item.myAnswer = item.myAnswer + chooseAnswer
                }
            }
            this.examList[index] = item;
            console.log("examList",this.examList,index,chooseAnswer);
        },
        // 展示答案
        submit() {
            let checkIndex =this.examList.findIndex(item=> !item.myAnswer)
            if(checkIndex === -1) {
                let finishExamList = [];
                let myScore = 0;
                 this.examList.map(item=>{
                    finishExamList.push({
                        examineeAnswer: item.myAnswer,
                        questionId: item.id,
                        questionType: item.questionType
                    })
                    item.trueOrFalse = item.myAnswer === item.rightAnswer;
                    myScore += item.trueOrFalse ? 2 : 0;
                    return item;
                })
                finishExam({...this.reqQuery, finishExamQuestionsList: finishExamList}).then(r=>{
                    if (r.Result == 1) {
                        this.scrollTop()
                        this.showAnswer = true; // 展示答案
                        this.myScore = myScore;
                        this.$toast({
                            duration: 3000,
                            message: '提交成功，可核对答案',
                            type: 'success'
                        })
                    }else {
                        this.$toast(r.Message);
                    }
                });
            }else {
                this.$toast(`请填写题目${checkIndex+1}`)
                this.scrollTo(checkIndex)
            }
        },
        // 提交监听滚动定位问题 
        scrollTo(checkIndex) {
            var anchor = document.getElementById('elem' + checkIndex);
            anchor.scrollIntoView();
        },
        scrollTop() {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        },
        reloadNewExam() {
            this.examList = [];
            this.showAnswer = false;
            this.myScore = 0;
            this.init();
        }
    }
}
</script>

<style lang="scss" scoped>
.page {
	padding: 0 0 40px 0;
}
.score-block {
    font-size: 24px;
    background: #eaecf5;
    padding: 20px 20px 10px 20px;
    span {
        color: red;
        font-weight: bold;
        font-size: 27px;
    }
    p {
        color: red; 
    }
}
.confirm-btn {
	width: 302px;
	height: 45px;
	background: #E3655E;
	border-radius: 90px;
	text-align: center;
	line-height: 45px;
	color: #fff;
	margin: 20px auto;
}
.confirm-btn .icon-small{
	margin-left: 20px;
	line-height: 1;
}
.confirm-btn.disabled{
	background: #A6A5A5;
}
.primary-bg {
	background-color: #FF7326;
}
.choose-q-block{
	font-size: 18px;
	line-height: 18px;
	display: grid;
	gap: 8px;
    margin: 10px 20px 0 20px;
}
.choose-q-block .choice-q-title, .info-q .title{
	font-size: 18px;
	line-height: 28px;
}
.choose-q-block .choice-q-title span {
	display: inline-block;
	background-color:#FF7326;
	color: #fff;
	border-radius: 2px 2px 2px 0;
	width: 36px;
	height: 18px;
	line-height: 18px;
	text-align: center;
	font-size: 12px;
    margin-left: 5px;
}
.choose-q-block .choice-q-title span.dx{
    background: #E3655E;
}
.choose-q-block .choice-q-title span.pd{
	background: #08B018;
}
.choose-q-block .abcd {
	font-size: 16px;
	color: #7C7F87;
	line-height: 19px;
	margin-left: 30px;
    position: relative;
    span {
        padding: 2.5px 0 2.5px 5px;
        display: inline-block;
    }
}
.choose-q-block .abcd::before {
    position: absolute;
	width: 27px;
	height: 27px;
	margin-left: -30px;
	border: 1px solid #E8E7E5;
	border-radius: 50%;
	color: #7C7F87;
	font-size: 16px;
	display: inline-block;
	text-align: center;
	line-height: 27px;
	margin-right: 10px;
    box-sizing: content-box;
}
.choose-q-block .abcd-a::before {
	content: "A";
}
.choose-q-block .abcd-b::before {
	content: "B";
}
.choose-q-block .abcd-c::before {
	content: "C";
}
.choose-q-block .abcd-d::before {
	content: "D";
}
.choose-q-block .answer {
    color: red;
}
.choose-q-block .abcd.active {
	font-size: 16px;
	color: #FF7326;
	line-height: 19px;
}
.choose-q-block .abcd.active::before {
	background: #FF7326;
	color: #fff;
}
</style>
